<template>
  <div id="app" :class="locale">
    <div>
      <app-header/>
      <main>
        <router-view/>
      </main>
      <Footer v-if="isHome"/>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import AppHeader from '@/components/AppHeader'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  computed: {
    isHome () {
      return this.$route.name === 'home'
    },
    locale () {
      return store.state.locale === 'cn' ? 'zh' : 'en'
    }
  },
  metaInfo: {
    titleTemplate (chunk) {
      return chunk ? `${chunk.replace(/\r?\n|\r/g, ' ')} - Times Museum` : 'Times Museum'
    },
    htmlAttrs: {
      lang: store.state.locale === 'cn' ? 'zh' : 'en'
    }
  },
  components: { AppHeader, Footer },
  mounted () {
    window.setTimeout(() => {
      window.prerenderReady = true
    }, 4000)
  }
}
</script>

<style lang="stylus">
@import 'css/app.styl'
</style>
